module.exports = __webpack_public_path__ + "img/chat.2f1221a4.png";